import { render, staticRenderFns } from "./PersonProfile.vue?vue&type=template&id=4088b415"
import script from "./PersonProfile.vue?vue&type=script&lang=ts"
export * from "./PersonProfile.vue?vue&type=script&lang=ts"
import style0 from "./PersonProfile.vue?vue&type=style&index=0&id=4088b415&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports